<template>
  <section class="app-main">
    <keep-alive exclude="/[^.*Detail$]/">
      <router-view v-if="$route.meta.isCache" :key="key" />
    </keep-alive>
    <router-view v-if="!$route.meta.isCache" :key="key" /> 
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  },
  data() {
    return {
        include: []
      };
  }   
}
</script>

<style lang="scss" scoped>
.app-main {
  //  flex: 1 0 auto;
  // height: 98%;
   //height: calc(100% - 90px);
  padding: 0 15px 1px 15px;
   scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
min-width: 1200px;
margin-bottom: 40px;
   
}
.app-main::-webkit-scrollbar {
  display: none;
}
.fixed-header + .app-main {
  padding-top: 80px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
